// src/Dashboard/pages/user/Boutique/components/BoutiqueToolbar.jsx

import React from "react";
import { FaFilter, FaSearch, FaTimes } from "react-icons/fa";

export default function BoutiqueToolbar({
  ui,
  categories = [],
  updateUi,
  debouncedSearch,
  setDebouncedSearch,
  onReset,
}) {
  const fieldClass =
    "w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white";

  return (
    <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-900/60">
      <div className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 text-sm font-bold text-slate-900 dark:text-white">
            <FaFilter />
            Filtres boutique
          </div>

          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            Recherchez un article, filtrez par catégorie ou disponibilité.
          </p>
        </div>

        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-900 px-3 py-2 text-xs font-bold text-white transition hover:bg-slate-800 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100"
        >
          <FaTimes />
          Réinitialiser
        </button>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Recherche
          </label>

          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="text"
              value={debouncedSearch}
              onChange={(event) => setDebouncedSearch(event.target.value)}
              placeholder="Nom, description, taille..."
              className="w-full rounded-2xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            />
          </div>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Catégorie
          </label>

          <select
            value={ui.category}
            onChange={(event) => updateUi({ category: event.target.value })}
            className={fieldClass}
          >
            <option value="all">Toutes</option>

            {categories.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Stock
          </label>

          <select
            value={ui.stock}
            onChange={(event) => updateUi({ stock: event.target.value })}
            className={fieldClass}
          >
            <option value="all">Tous les articles</option>
            <option value="available">Disponibles</option>
            <option value="out">Stock épuisé</option>
          </select>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Tri
          </label>

          <select
            value={ui.sort}
            onChange={(event) => updateUi({ sort: event.target.value })}
            className={fieldClass}
          >
            <option value="order">Ordre d’affichage</option>
            <option value="alpha">Nom A-Z</option>
            <option value="priceAsc">Prix croissant</option>
            <option value="priceDesc">Prix décroissant</option>
          </select>
        </div>
      </div>
    </div>
  );
}